import { getFocus, useGet } from "state/jotai";
import { _bootstrap } from "state/store.bootstrap";
import {
  active_project,
} from "state/store.global";
import { useLocation } from "react-router-dom";

import { _project } from "state/store.projects";
import { useBreak } from "hooks/useBreak";
import { useState } from "react";
import { IsometryDualMenu } from "./IsometryDualMenu";
import { OverviewDualMenu } from "./OverviewDualMenu";
import styled from "styled-components";
import { BREAK_ } from "constants";
import { useFilter } from "hooks/useFilter";
import { useDualMenuLogic } from "hooks/useDualMenuLogic";
import { isIframeMode } from "logging/logging";

export const DualMenu = ({ left, right, nav }) => {
  const isDesktop = useBreak("md_up");
  const isMobile  = useBreak("md_dn");
  const here      = useLocation().pathname;

  const { pin } = useGet(active_project);
  const type    = getFocus(_bootstrap, "type");
const iFrameEnabled = isIframeMode()
  const showFooter = ["isometry", "list"].some(i => here.includes(i));
  const isIsometry = here.includes("isometry");

  // ✅ hooks (your new system)
  const menu      = useDualMenuLogic();        // clickList, clickModel, flags
  const filter    = useFilter();      // filterState, toggleFilter

  const [state, setState] = useState(false);

  const showOverview =
    type === "poly" && pin === 0 && isIsometry && !isMobile;

  const sharedProps = {
    left,
    right,
    nav,
    isMobile,
    isIsometry,
    state,
    setState,

    // merged hooks
    ...menu,
    ...filter,
  };

  return (
    <>
      {showOverview ? (
        <OverviewDualMenu {...sharedProps} />
      ) : showFooter ? (
        <IsometryDualMenu {...sharedProps} />
      ) : null}

      {((isIsometry && !isDesktop && !iFrameEnabled) || here.includes("list")) && (
        <BgWhiteFooter />
      )}

    </>
  );
};

const BgWhiteFooter = styled.div`
  position: fixed;
  height: 94px;
  background: transparent;
  bottom: 0px;
    pointer-events: none;
  left: 0;
  width: 100%;
  border-radius: 6px 6px 0px 0px;
   ${BREAK_.md_dn} {
     height: 85.2125px;
   }
}
`
